import { Component, OnInit, OnChanges, SimpleChanges, OnDestroy, ViewChild } from '@angular/core';
import { UserService } from "../../../Shared/Services/user.service";
import { default as GridColumnsJSON } from './in-transactions-columns.json';
import { APIURL } from "../../../Shared/Constant/API_Urls";
import { GridService } from "../../../Shared/Services/grid.service";
import { HttpErrorResponse } from "@angular/common/http";
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { MessageService } from 'primeng/api';
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { Subscription } from 'rxjs';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { QuickSearchComponent } from "app/Shared/Component/quick-search/quick-search.component";
import { CommonModule, NgClass } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ToastModule } from 'primeng/toast';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { Table, TableModule } from 'primeng/table';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { QuickviewSidebarComponent } from 'app/Shared/Component/quickview-sidebar/quickview-sidebar.component';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';

@Component({
  selector: 'app-in-transactions',
  imports: [FilterPanelComponent, QuickSearchComponent,
    CommonModule, MatProgressSpinner, ToastModule, ExportToCSVSComponent, QuickviewSidebarComponent,
    TableModule, ButtonModule, DialogModule, FormsModule, MatTooltipModule
  ],
  templateUrl: './in-transactions.component.html',
  styleUrls: ['./in-transactions.component.scss']
})
export class InTransactionsComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('dt') dt!: Table | any;
  quickFilterArray: any = GridColumnsJSON["Quick-Search-Fields"];
  GridColumns: any = GridColumnsJSON["Grid-Columns"];
  exportGridColumns: any = [];
  cols: any = [];
  isQuickViewOpenClose: boolean = false;
  Dataset: any[] = [];
  LastExecutionODRDate!: any[];
  DefaultFilterArray: any = [];
  isLoadingResults = true;
  PageName = "In_Transactions";
  Limit: any = { 'Start': '', 'End': '' };
  selectedRow: any = [];
  totalRecords: any;
  rowcount!: number;
  startLimit: any = 0;
  pageNumber: any = 1;
  priviousStartLimit: any;
  endLimit!: number;
  subscription!: Subscription;
  tableName: any = null;
  tablesData: any[] = [];
  sortData: any = { field: '', order: 0 };
  sortClickCounter: number = 0;

  constructor(
    private userService: UserService,
    private gridService: GridService,
    private emitterService: EmitterService,
    public constantService: ConstantService,
    private messageService: MessageService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    private sortPipe: SortPipe) {
  }

  ngAfterViewInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.defaultFilter();
    this.loadInitialData();
  }

  ngOnInit(): void {
    this.rowcount = this.gridService.getGridRowsCount();
    this.Limit = { 'Start': '0', 'End': this.rowcount };
    this.totalRecords = this.rowcount;
    this.Dataset = [];
    this.defaultFilter();
    this.loadInitialData();
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getData();
      }
    });
  }

  mapSqlTypeToGridType(sqlType: string): string {
    const raw = sqlType ?? '';
    const baseType = raw.includes('(') ? raw.substring(0, raw.indexOf('(')).trim().toUpperCase() : raw.trim().toUpperCase();
    if (baseType === 'decimal') return 'float';
    if (baseType === 'tinyint') return 'boolean';
    return 'string';
  }

  getColumnInfo(date: any) {
    const payload = {
      date: this.userService.getyyyyMMddDateFormate(date) ?? '',
      mpid: this.userService.getActiveMPID(),
      tableName: null
    };

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(APIURL.ODR_In_Transactions_Columns),
      payload
    ).subscribe({
      next: (response: any) => {
        const tables: any[] = response?.Data ?? [];
        this.tablesData = tables;
        this.setTableName();
        this.getData();
      },
      error: (_err: HttpErrorResponse) => {
        this.tablesData = [];
        this.tableName = null;
        this.applyColumns([]);
        this.getData();
      }
    });
  }

  setTableName() {
    if (!this.tablesData || this.tablesData.length === 0) {
      this.tableName = null;
      this.applyColumns([]);
      return;
    }

    const sourceFilter = this.DefaultFilterArray?.find((f: any) => f.columnname === 'Source');
    const sourceValue = sourceFilter?.values ? String(sourceFilter.values).split(',')[0].trim() : '';

    const matchedTable = sourceValue
      ? this.tablesData.find((table: any) => String(table.omsSystem).toLowerCase() === sourceValue.toLowerCase())
      : null;

    const selectedTable = matchedTable ?? this.tablesData[0];
    this.tableName = selectedTable?.tableName ?? null;
    this.applyColumns(selectedTable?.columns ?? []);
  }

  applyColumns(columns: any[]) {
    const staticColDefs: any[] = GridColumnsJSON["Grid-Columns"];

    const dynamicGridColumns = columns.map(col => ({
      display: "true",
      ui_columnname: col.columnName,
      db_columnname: col.columnName,
      datatype: this.mapSqlTypeToGridType(col.columnType),
      mappingkey: col.columnName,
      dropdown: "NO",
      isdefault: "false",
      disabled: "false",
      value: "",
      dropdowntype: "singleselect",
      dropdownvalue: ""
    }));

    this.GridColumns = [...staticColDefs, ...dynamicGridColumns];

    this.cols = [
      ...staticColDefs.map((col: any) => ({ header: col.ui_columnname, field: col.mappingkey, datatype: col.datatype })),
      ...dynamicGridColumns.map(col => ({ header: col.ui_columnname, field: col.mappingkey, datatype: col.datatype }))
    ];

    this.exportGridColumns = [
      ...staticColDefs.filter((col: any) => col.disabled !== 'true'),
      ...dynamicGridColumns
    ];
  }

  onView(index: any, row: any) {
    this.isQuickViewOpenClose = false;
    this.selectedRow = [];
    this.selectedRow.push(row);
    this.isQuickViewOpenClose = true;
  }

  onViewOrderID(rowData: any) {
    this.emitterService.isODROrderViewerOpenCloseEvent.emit(
      {
        display: true,
        rowData: rowData,
        pageName: 'ODR'
      });
  }

  updateDefaultArray($event: any) {
    this.emitterService.ResetQuickFilterPanelEvent.emit("All");
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.setTableName();
    this.getData();
  }

  clearQuickSearch($event: any) {
    this.emitterService.ResetQuickFilterPanelEvent.emit("All");
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.setTableName();
    this.getData();
  }

  FilterApplyFilterEvent(event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;
    this.startLimit = 0;
    this.Limit.Start = 0;

    const reportDateFilter = event?.find((f: any) => f.columnname === 'reportDate');
    const date = reportDateFilter?.values?.[0] ?? this.userService.ODR_ProcessedTransactionReportDate ?? new Date();

    this.getColumnInfo(date);
  }

  QuickViewCloseEvent(event: any) {
    this.selectedRow = [];
    this.isQuickViewOpenClose = false;
  }

  changePage(event: { first: any; rows: number; }) {
    this.startLimit = event.first;
    this.rowcount = event.rows;
    this.endLimit = this.startLimit + this.rowcount;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.priviousStartLimit = this.startLimit;
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;
    this.getData();
  }

  sort(event: any) {
    if (this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
      this.sortClickCounter = this.sortClickCounter + 1;
    } else {
      this.sortClickCounter = 1;
    }
    if (this.sortClickCounter !== 3) {
      let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
      this.sortData.field = event.multisortmeta[0].field;
      this.sortData.order = sortOrder;
      this.Dataset = this.sortPipe.transform(this.Dataset, this.sortData.order, this.sortData.field);
    } else {
      if (this.dt.multiSortMeta != undefined && this.dt.multiSortMeta?.length > 0) {
        this.dt.multiSortMeta[0].field = '';
        this.dt.multiSortMeta[0].order = 0;
      }
    }
  }

  defaultFilter() {
    let date = this.userService.ODR_ProcessedTransactionReportDate;
    this.LastExecutionODRDate = [date, date];
    this.DefaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Date', 'columnname': 'reportDate', 'filterby': '', 'values': this.LastExecutionODRDate, 'dateFilterValue': date, 'dateFilterBy': 'Report Date', 'time': '', 'datatype': 'clientDataSingleDate', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { "isdefault": "true", "label": "Venue Name", "columnname": "VenueName", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": true, },
      { "isdefault": "true", "label": "Symbol", "columnname": "Symbol", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": true, },
      { "isdefault": "true", "label": "Order ID", "columnname": "OrderID", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": true, },
      { "isdefault": "true", "label": "Source", "columnname": "Source", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": true, },
    ];
    this.Limit.Start = 0;
  }

  async loadInitialData() {
    if (!this.userService.ODR_ProcessedTransactionReportDate) {
      await this.userService.getODRLastReportedDate();
    }

    let date = this.userService.ODR_ProcessedTransactionReportDate ?? new Date();
    this.LastExecutionODRDate[0] = date;
    this.LastExecutionODRDate[1] = date;
    this.DefaultFilterArray[0].dateFilterValue = typeof date === 'object' ? date : this.userService.getFormatedDate(date);
    this.getColumnInfo(date);
  }

  getData() {
    this.isLoadingResults = true;
    this.gridService.prepareData(APIURL.ODR_In_Transactions, this.DefaultFilterArray, this.Limit, "In_Transactions", this.tableName)
      .subscribe({
        next: (Element: any) => {
          this.isLoadingResults = false;
          let dataset: any = Element;
          this.Dataset = dataset.Data;
          this.totalRecords = dataset.totalCount;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
        }, error: (err: HttpErrorResponse) => {
          this.Dataset = [];
          this.totalRecords = 0;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
          this.isLoadingResults = false;
        }
      });
  }

  exportToCSV(event: { isExportMaxRows: any; gridColumn: any; }) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    if (event.isExportMaxRows) {
      this.Limit = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    } else {
      this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    }
    this.gridService.getData(
      APIURL.ODR_In_Transactions,
      this.DefaultFilterArray,
      this.Limit,
      this.gridService.getEventsList(this.DefaultFilterArray, 'type'),
      this.PageName,
      undefined,
      this.tableName
    ).subscribe({
      next: (Element: any) => {
        let dataset: any = Element;
        let data = dataset.Data;

        if (data.length > 0) {
          data.forEach((col: { originalJSON: any; }) => {
            delete col.originalJSON;
          });
          const options: any = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title: 'RSMS_' + this.PageName + '_' + this.userService.getyyyyMMddDateFormate(new Date()),
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true,
            filename: this.userService.getActiveMPID() + '_RSMS_' + this.PageName + '_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
          };
          const csvData = this.constantService.getExportData(data, event.gridColumn);
          const csv = generateCsv(options)(csvData);
          const blob = asBlob(options)(csv);
          saveAs(blob, options.filename);
          this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
          this.userService.logUserActivity('Export CSV', null, {
            'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
          this.userService.logUserActivity('Export CSV', null, {
            'Text1': 'No data found',
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        }
        this.emitterService.exportToCSVData.emit(true);
      }, error: (err: HttpErrorResponse) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
        this.userService.logUserActivity('Export CSV', null, {
          'Text1': 'Error while Exporting',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
}
